import { IntermediarioState } from "./intermediario.types";
import { Dispatch } from "redux";
import { IAction, IStore } from "../store";
import { History } from "history";
import { FAILURE, REQUEST, SUCCESS } from "../../utils/actionsTypes";
import { Api } from "../../api";
import { getPath } from "../../utils/getPath";

export enum IntermediarioActionType {
  LOAD = "intermediario/LOAD",
  CLEAR_ERROR = "intermediario/CLEAR_ERROR",
}

export const intermediarioInitialState: IntermediarioState = {
  data: undefined,
  id: "",
  loading: false,
  error: "",
};

export const intermediarioReducer = (
  state: IntermediarioState = intermediarioInitialState,
  action: IAction,
): IntermediarioState => {
  switch (action.type) {
    case REQUEST(IntermediarioActionType.LOAD):
      return {
        ...state,
        id: action.payload,
        loading: true,
      };

    case SUCCESS(IntermediarioActionType.LOAD):
      return {
        ...state,
        data: action.payload,
        loading: false,
      };

    case FAILURE(IntermediarioActionType.LOAD):
      return {
        ...state,
        id: "",
        data: undefined,
        loading: false,
        error: action.payload,
      };

    case IntermediarioActionType.CLEAR_ERROR:
      return {
        ...state,
        error: "",
      };

    default:
      return state;
  }
};

// Action creator

// Thunk
export const loadIntermediario =
  (id: string, history: History) =>
  (dispatch: Dispatch, getState: () => IStore): void => {
    dispatch({ type: REQUEST(IntermediarioActionType.LOAD), payload: id });
    Api.loadIntermediario(id)
      .then((data) => {
        dispatch({ type: SUCCESS(IntermediarioActionType.LOAD), payload: data });
      })
      .catch((error) => {
        console.log("ERROR", error);
        const step = getState().engine.step;
        dispatch({ type: FAILURE(IntermediarioActionType.LOAD), payload: `${error}` });
        history.replace(getPath(step));
      });
  };
